import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    USEREDITFORMBIRTHDATE: {
        id: 'UserEditForm.birtDateRequired',
        defaultMessage: 'Birth Date is a required field',
    },
    USEREDITFORMBIRTHDATETYPE: {
        id: 'UserEditForm.birtDateType',
        defaultMessage: 'Birth Date be in a date format',
    },
});

export default enumMessages;
